// extracted by mini-css-extract-plugin
module.exports = {"container":"_35Go5Ql9OOiK4_jZiVvDn6"};